<template>
    <div class="base-pwd-pay-setup" :class="{'pwdpayset-sp': $store.state.screen == 1}">
        <div class="content">
            <div class="title">设置支付密码</div>
            <div class="tips">支付密码用于游戏内使用平台币消费时所需的密码。</div>
            <div>
                <input class="val" type="text" maxlength="16" placeholder="设置支付密码（6~16位数字或字母）" v-model="payPwd" />
                <input class="val" type="text" maxlength="16" placeholder="再次确认支付密码" v-model="comPayPwd" />
            </div>
            <div class="btn">
                <div class="item" @click="onOut">取消</div>
                <div class="item" @click="submit">确定</div>
            </div>
        </div>
        <transition name="component-fade" mode="out-in">
            <TheTips :msg='msg' v-if="msg" />
        </transition>
    </div>
</template>

<script>
    import TheTips from '@/components/TheTips'

    export default {
        components: {
            TheTips
        },
        data () {
            return {
                msg: null,
                payPwd: '',
                comPayPwd: ''
            }
        },
        methods: {
            // 关闭弹窗
            onOut () {
                this.$emit('childPaySetup', null)
            },
            // 设置支付密码
            submit () {
                // 数字或字母正则
                // let reg = /^[0-9a-zA-Z]*$/g
                let accountData = JSON.parse(sessionStorage.getItem('accountData'))
                let h5LoginData = JSON.parse(sessionStorage.getItem('h5LoginData'))    //+
                if (this.payPwd.replace(/\s*/g, "") || this.comPayPwd.replace(/\s*/g, "")) {
                    if (this.payPwd.replace(/\s*/g, "").length >= 6 || this.comPayPwd.replace(/\s*/g, "").length >= 6) {
                        if (this.payPwd.replace(/\s*/g, "") == this.comPayPwd.replace(/\s*/g, "")) {
                            let options = {
                                uid: accountData.uid,
                                appid: accountData.appid,
                                channel: h5LoginData.channel,
                                system: this.config.system,
                                pay_password: this.payPwd
                            }
                            options.sign = this.util.getSign(options, accountData.appkey)
                            this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=set_pay_pass',this.$qs.stringify(options)).then(res => {
                                if (res.data.status == 1) {
                                    this.msg = '设置成功'
                                    setTimeout(() => {
                                        this.msg = null
                                        this.$emit('childPaySetup', null)
                                    }, 1000)
                                } else {
                                    this.msg = res.data.msg
                                    setTimeout(() => {
                                        this.msg = null
                                    }, 2000)
                                }
                            }).
                            catch(o => {
                                this.msg = '请求失败'
                                setTimeout(() => {
                                    this.msg = null
                                }, 2000)
                            })
                        } else {
                            this.msg = '两次密码输入不一致'
                            setTimeout(() => {
                                this.msg = null
                            }, 2000)
                        }
                    } else {
                        this.msg = '密码长度为6到16位'
                        setTimeout(() => {
                            this.msg = null
                        }, 2000)
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../static/tctransition";
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-pwd-pay-setup {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        transition: all 0.3s;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        .content {
            width: 840px;
            overflow: hidden;
            border-radius: 18px;
            background: $color;
            overflow: hidden;
            padding: 0 60px 60px;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
                height: 160px;
                font-size: 51px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .tips {
                font-size: 42px;
                margin-bottom: 50px;
            }
            .val {
                width: 100%;
                height: 120px;
                color: #fff;
                font-size: 39px;
                border-radius: 18px;
                border: 0;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                margin-bottom: 30px;
                outline: none;
            }
            .val:last-child {
                margin-bottom: 0;
            }
            input::-webkit-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-moz-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-ms-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            input::-o-input-placeholder{
                color:rgba(255, 255, 255, 0.5);
            }
            .btn {
                height: 120px;
                margin-top: 55px;
                display: flex;
                justify-content: space-between;
                .item {
                    width: 345px;
                    height: 120px;
                    color: $color;
                    font-size: 39px;
                    border-radius: 18px;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .item:first-child {
                    background: rgba(255, 255, 255, 0.8);
                }
            }
        }
    }
    // 竖屏css
    .pwdpayset-sp {
        .content {
            width: 1527px;
            border-radius: 32px;
            padding: 0 90px 90px;
            .title {
                height: 290px;
                font-size: 92px;
            }
            .tips {
                font-size: 76px;
                margin-bottom: 90px;
            }
            .val {
                height: 200px;
                font-size: 70px;
                border-radius: 32px;
                padding: 0 81px;
                margin-bottom: 54px;
            }
            .btn {
                height: 200px;
                margin-top: 100px;
                .item {
                    width: 627px;
                    height: 200px;
                    font-size: 70px;
                    border-radius: 32px;
                }
            }
        }
    }
</style>